webpackJsonp([110308036455227],{

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JM = __webpack_require__(66);
	
	var _arrowUp = __webpack_require__(89);
	
	var _arrowRight = __webpack_require__(88);
	
	var _arrowDown = __webpack_require__(86);
	
	var _arrowLeft = __webpack_require__(87);
	
	var _socialDribbble = __webpack_require__(90);
	
	var _socialGithub = __webpack_require__(91);
	
	var _socialTwitter = __webpack_require__(93);
	
	var _socialMail = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Type = {
	  JM: function JM(props) {
	    return _react2.default.createElement(_JM.ReactComponent, props);
	  },
	  arrowUp: function arrowUp(props) {
	    return _react2.default.createElement(_arrowUp.ReactComponent, props);
	  },
	  arrowRight: function arrowRight(props) {
	    return _react2.default.createElement(_arrowRight.ReactComponent, props);
	  },
	  arrowDown: function arrowDown(props) {
	    return _react2.default.createElement(_arrowDown.ReactComponent, props);
	  },
	  arrowLeft: function arrowLeft(props) {
	    return _react2.default.createElement(_arrowLeft.ReactComponent, props);
	  },
	  socialDribbble: function socialDribbble(props) {
	    return _react2.default.createElement(_socialDribbble.ReactComponent, props);
	  },
	  socialGithub: function socialGithub(props) {
	    return _react2.default.createElement(_socialGithub.ReactComponent, props);
	  },
	  socialTwitter: function socialTwitter(props) {
	    return _react2.default.createElement(_socialTwitter.ReactComponent, props);
	  },
	  socialMail: function socialMail(props) {
	    return _react2.default.createElement(_socialMail.ReactComponent, props);
	  }
	};
	
	exports.default = function (_ref) {
	  var type = _ref.type,
	      className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['type', 'className']);
	
	  var Svg = Type[type];
	
	  if (typeof Svg === 'function') {
	    var classes = 'svg-icon';
	
	    if (className !== undefined) {
	      classes = classes + ' ' + className;
	    }
	
	    return _react2.default.createElement(Svg, _extends({ className: classes }, rest));
	  }
	  return null;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M30.046.036l.104.182 29.915 53.863H19.831l13.237-23.843 3.44 6.176-6.462 11.648H49.85L26.606 6.212l3.44-6.176zm-6.88 12.352l3.44 6.176L6.879 54.055H0l23.166-41.667zm56.704 53.68H.026v-5.993h79.87v5.993h-.026zm-6.854-12.013L49.85 12.388l-3.049 5.472-3.413-6.176L49.85.036 79.87 54.08h-6.854v-.026z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 80,
	    height: 67,
	    viewBox: "0 0 80 67"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODBweCIgaGVpZ2h0PSI2N3B4IiB2aWV3Qm94PSIwIDAgODAgNjciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjEgKDUxMTQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Mb2dvPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJfUGFydHMvRnJhbWUvQmFyL0xvZ28iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtNy4wMDAwMDApIiBmaWxsPSIjMEIwRTEzIj4KICAgICAgICAgICAgPGcgaWQ9IkxvZ28iPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMwLjA0NTYwMjYsNy4wMzU4MzA2MiBMMzAuMTQ5ODM3MSw3LjIxODI0MTA0IEw2MC4wNjUxNDY2LDYxLjA4MTQzMzIgTDE5LjgzMDYxODksNjEuMDgxNDMzMiBMMzMuMDY4NDAzOSwzNy4yMzc3ODUgTDM2LjUwODE0MzMsNDMuNDEzNjgwOCBMMzAuMDQ1NjAyNiw1NS4wNjE4ODkzIEw0OS44NTAxNjI5LDU1LjA2MTg4OTMgTDI2LjYwNTg2MzIsMTMuMjExNzI2NCBMMzAuMDQ1NjAyNiw3LjAzNTgzMDYyIEwzMC4wNDU2MDI2LDcuMDM1ODMwNjIgWiBNMjMuMTY2MTIzOCwxOS4zODc2MjIxIEwyNi42MDU4NjMyLDI1LjU2MzUxNzkgTDYuODc5NDc4ODMsNjEuMDU1Mzc0NiBMMy43MzAzNDkzNmUtMTQsNjEuMDU1Mzc0NiBMMjMuMTY2MTIzOCwxOS4zODc2MjIxIEwyMy4xNjYxMjM4LDE5LjM4NzYyMjEgWiBNNzkuODY5NzA2OCw3My4wNjg0MDM5IEwwLjAyNjA1ODYzMTksNzMuMDY4NDAzOSBMMC4wMjYwNTg2MzE5LDY3LjA3NDkxODYgTDc5Ljg5NTc2NTUsNjcuMDc0OTE4NiBMNzkuODk1NzY1NSw3My4wNjg0MDM5IEw3OS44Njk3MDY4LDczLjA2ODQwMzkgWiBNNzMuMDE2Mjg2Niw2MS4wNTUzNzQ2IEw0OS44NTAxNjI5LDE5LjM4NzYyMjEgTDQ2LjgwMTMwMjksMjQuODU5OTM0OSBMNDMuMzg3NjIyMSwxOC42ODQwMzkxIEw0OS44NTAxNjI5LDcuMDM1ODMwNjIgTDc5Ljg2OTcwNjgsNjEuMDgxNDMzMiBMNzMuMDE2Mjg2Niw2MS4wODE0MzMyIEw3My4wMTYyODY2LDYxLjA1NTM3NDYgWiI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M6.994 9.514l3.374-3.36 1.25 1.244L5.994 13 .37 7.398l1.25-1.244 3.374 3.36V0h2z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 12,
	    height: 13,
	    viewBox: "0 0 12 13"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTIgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1kb3duPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy9BcnJvdy9Eb3duIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4wMDAwMDAsIC0xLjAwMDAwMCkiIGZpbGw9IiMwQjBFMTMiPgogICAgICAgICAgICA8ZyBpZD0iYXJyb3ctZG93biI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iOC45OTQwMDYzOCAxMC41MTQ0MzE1IDEyLjM2ODIzMzcgNy4xNTM2OTMxNSAxMy42MTgwMTI5IDguMzk4NDc2MjIgNy45OTQwMDYzOCAxNCAyLjM2OTk5OTg5IDguMzk4NDc2MjIgMy42MTk3NzkxMSA3LjE1MzY5MzE1IDYuOTk0MDA2MzggMTAuNTE0NDMxNSA2Ljk5NDAwNjM4IDEgOC45OTQwMDYzOCAxIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M3.486 6.994l3.36 3.374-1.244 1.25L0 5.994 5.602.37l1.244 1.25-3.36 3.374H13v2z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 13,
	    height: 12,
	    viewBox: "0 0 13 12"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTMgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1sZWZ0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy9BcnJvdy9MZWZ0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiMwQjBFMTMiPgogICAgICAgICAgICA8ZyBpZD0iYXJyb3ctbGVmdCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iNC40ODU1Njg0OSA4Ljk5NDAwNjM4IDcuODQ2MzA2ODUgMTIuMzY4MjMzNyA2LjYwMTUyMzc4IDEzLjYxODAxMjkgMSA3Ljk5NDAwNjM4IDYuNjAxNTIzNzggMi4zNjk5OTk4OSA3Ljg0NjMwNjg1IDMuNjE5Nzc5MTEgNC40ODU1Njg0OSA2Ljk5NDAwNjM4IDE0IDYuOTk0MDA2MzggMTQgOC45OTQwMDYzOCI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M9.514 6.994H0v-2h9.514L6.154 1.62 7.398.37 13 5.994l-5.602 5.624-1.244-1.25z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 13,
	    height: 12,
	    viewBox: "0 0 13 12"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTMgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1yaWdodDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvQXJyb3cvUmlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjAwMDAwMCwgLTIuMDAwMDAwKSIgZmlsbD0iIzBCMEUxMyI+CiAgICAgICAgICAgIDxnIGlkPSJhcnJvdy1yaWdodCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iMTEuNTE0NDMxNSA4Ljk5NDAwNjM4IDIgOC45OTQwMDYzOCAyIDYuOTk0MDA2MzggMTEuNTE0NDMxNSA2Ljk5NDAwNjM4IDguMTUzNjkzMTUgMy42MTk3NzkxMSA5LjM5ODQ3NjIyIDIuMzY5OTk5ODkgMTUgNy45OTQwMDYzOCA5LjM5ODQ3NjIyIDEzLjYxODAxMjkgOC4xNTM2OTMxNSAxMi4zNjgyMzM3Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M6.994 3.486V13h-2V3.486L1.62 6.846.37 5.602 5.994 0l5.624 5.602-1.25 1.244z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 12,
	    height: 13,
	    viewBox: "0 0 12 13"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTIgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy11cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvQXJyb3cvVXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjAwMDAwMCwgLTEuMDAwMDAwKSIgZmlsbD0iIzBCMEUxMyI+CiAgICAgICAgICAgIDxnIGlkPSJhcnJvdy11cCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iOC45OTQwMDYzOCA0LjQ4NTU2ODQ5IDguOTk0MDA2MzggMTQgNi45OTQwMDYzOCAxNCA2Ljk5NDAwNjM4IDQuNDg1NTY4NDkgMy42MTk3NzkxMSA3Ljg0NjMwNjg1IDIuMzY5OTk5ODkgNi42MDE1MjM3OCA3Ljk5NDAwNjM4IDEgMTMuNjE4MDEyOSA2LjYwMTUyMzc4IDEyLjM2ODIzMzcgNy44NDYzMDY4NSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M8 15.979c-4.411 0-8-3.584-8-7.99C0 3.584 3.589 0 8 0s8 3.584 8 7.99c0 4.405-3.589 7.989-8 7.989zm5.29-12.295c-.145.195-1.29 1.66-3.816 2.691a21.066 21.066 0 0 1 .6 1.34c2.274-.285 4.533.173 4.758.22a6.787 6.787 0 0 0-1.543-4.25zM6.398 1.365c.189.253 1.43 1.94 2.55 3.995 2.43-.91 3.458-2.29 3.58-2.465a6.836 6.836 0 0 0-6.131-1.53zM1.31 6.602c.306.004 3.121.016 6.317-.831a43.543 43.543 0 0 0-2.533-3.947A6.85 6.85 0 0 0 1.31 6.602zm1.612 5.96c.155-.264 2.03-3.365 5.555-4.503.089-.028.179-.055.269-.08a22.824 22.824 0 0 0-.554-1.159c-3.412 1.02-6.724.977-7.023.971a6.792 6.792 0 0 0 1.753 4.771zm7.746 1.72c-.101-.6-.498-2.686-1.458-5.175l-.045.015c-3.854 1.341-5.237 4.01-5.36 4.261A6.805 6.805 0 0 0 8 14.823c.947 0 1.849-.193 2.67-.542zm4.078-5.199c-.234-.074-2.115-.634-4.257-.292.894 2.453 1.258 4.45 1.328 4.866a6.835 6.835 0 0 0 2.929-4.574z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 16,
	    height: 16,
	    viewBox: "0 0 16 16"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M8 0A8 8 0 0 0 5.47 15.59c.4.074.546-.173.546-.385 0-.19-.006-.693-.01-1.36-2.226.483-2.695-1.073-2.695-1.073-.364-.924-.888-1.17-.888-1.17-.727-.496.055-.486.055-.486.803.056 1.225.824 1.225.824.713 1.222 1.872.87 2.328.665.073-.517.28-.87.508-1.07-1.776-.201-3.644-.888-3.644-3.953 0-.874.312-1.588.824-2.147-.083-.202-.357-1.016.078-2.117 0 0 .671-.215 2.2.82A7.662 7.662 0 0 1 8 3.868c.68.004 1.364.092 2.003.27 1.528-1.035 2.198-.82 2.198-.82.436 1.101.162 1.915.08 2.117.512.56.822 1.273.822 2.147 0 3.073-1.87 3.75-3.653 3.947.288.247.543.735.543 1.482 0 1.069-.01 1.932-.01 2.194 0 .214.144.463.55.385A8 8 0 0 0 8 0",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 16,
	    height: 16,
	    viewBox: "0 0 16 16"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M1.282 0h13.436c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77v9.436c0 .446-.046.607-.134.77a.909.909 0 0 1-.378.378c-.163.088-.324.134-.77.134H1.282c-.446 0-.607-.046-.77-.134a.909.909 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77V1.282C0 .836.046.675.134.512A.909.909 0 0 1 .512.134C.675.046.836 0 1.282 0zM8 6.998l-5.172-5.17a.708.708 0 0 0-1 1L8 9l6.173-6.172a.708.708 0 1 0-1.001-1L8 6.997z",
	  fill: "#0B0E13",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 16,
	    height: 12,
	    viewBox: "0 0 16 12"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M5.031 13.5c6.038 0 9.34-5.002 9.34-9.34 0-.142 0-.283-.01-.424A6.679 6.679 0 0 0 16 2.037c-.6.266-1.235.44-1.885.517A3.294 3.294 0 0 0 15.557.738a6.578 6.578 0 0 1-2.085.797 3.286 3.286 0 0 0-5.594 2.993A9.319 9.319 0 0 1 1.114 1.1 3.285 3.285 0 0 0 2.13 5.481 3.258 3.258 0 0 1 .64 5.07v.041A3.284 3.284 0 0 0 3.273 8.33c-.483.132-.99.151-1.482.056a3.286 3.286 0 0 0 3.067 2.28A6.586 6.586 0 0 1 0 12.025a9.293 9.293 0 0 0 5.031 1.472",
	  fill: "#0B0E13",
	  fillRule: "nonzero"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 16,
	    height: 14,
	    viewBox: "0 0 16 14"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(176);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(63);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Heading = __webpack_require__(18);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _ProjectCard = __webpack_require__(64);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	var _Button = __webpack_require__(47);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Svg = __webpack_require__(65);
	
	var _Svg2 = _interopRequireDefault(_Svg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ProjectCover = function ProjectCover(props) {
	  var src = props.src,
	      rest = _objectWithoutProperties(props, ['src']);
	
	  var _ref = src && src.childImageSharp ? src.childImageSharp : {},
	      sizes = _ref.sizes;
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: 'project-cover' }, rest),
	    src && _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes })
	  );
	};
	
	var ProjectMeta = function ProjectMeta(props) {
	  var client = props.client,
	      role = props.role,
	      rest = _objectWithoutProperties(props, ['client', 'role']);
	
	  return _react2.default.createElement(
	    'dl',
	    _extends({ className: 'grid-cell u-1of3 u-sm-full' }, rest),
	    _react2.default.createElement(
	      'dt',
	      null,
	      'Client'
	    ),
	    _react2.default.createElement(
	      'dd',
	      null,
	      client
	    ),
	    _react2.default.createElement(
	      'dt',
	      null,
	      'Role'
	    ),
	    _react2.default.createElement(
	      'dd',
	      null,
	      role
	    )
	  );
	};
	
	var ProjectDescription = function ProjectDescription(props) {
	  var html = props.html,
	      rest = _objectWithoutProperties(props, ['html']);
	
	  return _react2.default.createElement('div', _extends({ className: 'grid-cell', dangerouslySetInnerHTML: { __html: html } }, rest));
	};
	
	var ProjectDetails = function ProjectDetails(props) {
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: 'project-details grid-wrap' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid--gutters sm-grid--full' },
	      props.children
	    )
	  );
	};
	
	var getFeatures = function getFeatures(data) {
	  var features = [];
	  var filtered = Object.keys(data).filter(function (key) {
	    return (/^feature/.test(key)
	    );
	  }).reduce(function (obj, key) {
	    if (data[key] !== null) features.push(data[key]);
	    return obj;
	  }, {});
	
	  return features;
	};
	
	var ProjectFeatures = function ProjectFeatures(props) {
	  var features = props.features,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ['features', 'className']);
	
	  var classes = 'project-features grid grid--gutters sm-grid--full md-grid--full';
	
	  if (className !== undefined) {
	    classes = classes + ' ' + className;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classes }, rest),
	    features.map(function (feature, i) {
	      if (features.length > 2 && i > 0 && i <= 2) {
	        return _react2.default.createElement(ProjectFeature, { key: i, src: feature, className: 'u-sm--full' });
	      } else {
	        return _react2.default.createElement(ProjectFeature, { key: i, src: feature, className: 'u-full' });
	      }
	    })
	  );
	};
	
	var ProjectFeature = function ProjectFeature(props) {
	  var src = props.src,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ['src', 'className']);
	
	  var _ref2 = src && src.childImageSharp ? src.childImageSharp : {},
	      sizes = _ref2.sizes;
	
	  var classes = 'project-feature grid-cell';
	
	  if (className !== undefined) {
	    classes = classes + ' ' + className;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classes }, rest),
	    src && _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes })
	  );
	};
	
	var ProjectPagination = function ProjectPagination(props) {
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: 'project-pagination grid-wrap' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid--gutters sm-grid--full' },
	      props.children
	    )
	  );
	};
	
	var ProjectPaginationButton = function ProjectPaginationButton(props) {
	  var type = props.type,
	      rest = _objectWithoutProperties(props, ['type']);
	
	  var title = type === 'prev' ? 'Previous Project' : 'Next Project';
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: 'grid-cell' }, rest),
	    _react2.default.createElement(
	      _Heading2.default,
	      { level: '3' },
	      title
	    ),
	    props.children
	  );
	};
	
	exports.default = function (_ref3) {
	  var data = _ref3.data,
	      location = _ref3.location,
	      pathContext = _ref3.pathContext;
	  var project = data.project,
	      prev = data.prev,
	      next = data.next;
	  var frontmatter = project.frontmatter,
	      html = project.html;
	  var title = frontmatter.title,
	      client = frontmatter.client,
	      role = frontmatter.role,
	      thumbnail = frontmatter.thumbnail,
	      cover = frontmatter.cover,
	      theme_color = frontmatter.theme_color;
	
	  var features = getFeatures(frontmatter);
	  var isArchive = location.pathname.slice(9, 18) == '/archive/';
	  var meta = data.site.siteMetadata;
	  var siteTitle = title + ' \u2014 ' + meta.title;
	
	  var description = html.replace(/<[^>]+>/g, '');
	
	  var thumbnailUrl = void 0;
	  var thumbnailImage = thumbnail.childImageSharp.sizes.src;
	  if (true) {
	    thumbnailUrl = meta.siteUrl + thumbnailImage;
	  } else {
	    thumbnailUrl = thumbnailImage;
	  }
	
	  var more = {};
	  if (isArchive) {
	    more = {
	      label: 'More Archived',
	      location: '/projects/archive/'
	    };
	  } else {
	    more = {
	      label: 'More Projects',
	      location: '/projects/'
	    };
	  }
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: title },
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:title', content: siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: thumbnailUrl }),
	      theme_color && _react2.default.createElement(
	        'style',
	        { type: 'text/css' },
	        '\n          #header-logo svg path {\n            fill: ' + theme_color + ';\n          }\n          #header-logo a:hover {\n            opacity: 0.8;\n          }\n          #header-logo a:active,\n          #header-logo a:active:hover {\n            opacity: 1;\n          }\n        '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'header-wrap' },
	      _react2.default.createElement(
	        _Header2.default,
	        { className: 'grid-wrap' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { level: '2' },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-group grid grid--gutters' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-cell' },
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'link', to: more.location, className: 'button--outline button--sm u-sm-full' },
	              more.label
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-group grid-cell u-sm-1of2' },
	            prev && _react2.default.createElement(
	              _Button2.default,
	              { type: 'link', to: prev.fields.slug, className: 'button--outline button--sm u-sm-1of2 svg-link' },
	              _react2.default.createElement(_Svg2.default, { type: 'arrowLeft' })
	            ),
	            next && _react2.default.createElement(
	              _Button2.default,
	              { type: 'link', to: next.fields.slug, className: 'button--outline button--sm u-sm-1of2 svg-link' },
	              _react2.default.createElement(_Svg2.default, { type: 'arrowRight' })
	            )
	          )
	        )
	      )
	    ),
	    cover && _react2.default.createElement(ProjectCover, { src: cover }),
	    _react2.default.createElement(
	      ProjectDetails,
	      null,
	      _react2.default.createElement(ProjectMeta, { client: client,
	        role: role }),
	      _react2.default.createElement(ProjectDescription, { html: html })
	    ),
	    _react2.default.createElement(ProjectFeatures, { features: features }),
	    _react2.default.createElement(
	      ProjectPagination,
	      null,
	      prev && _react2.default.createElement(
	        ProjectPaginationButton,
	        { type: 'prev' },
	        _react2.default.createElement(_ProjectCard2.default, { slug: prev.fields.slug,
	          title: prev.frontmatter.title,
	          client: prev.frontmatter.client,
	          thumbnail: prev.frontmatter.thumbnail })
	      ),
	      next && _react2.default.createElement(
	        ProjectPaginationButton,
	        { type: 'next' },
	        _react2.default.createElement(_ProjectCard2.default, { slug: next.fields.slug,
	          title: next.frontmatter.title,
	          client: next.frontmatter.client,
	          thumbnail: next.frontmatter.thumbnail })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-js-317e8b6c3766d48eb486.js